import AppConfig from 'config'
import { devtools as _devtools } from 'zustand/middleware'

export const devtools: typeof _devtools = (fn, options?) =>
  _devtools(fn, { ...options, enabled: AppConfig.isDev } as Parameters<typeof _devtools>[1])
